<template>
    <v-container
        fluid
        class="py-0 px-0 my-0 mx-0"
    >
        <v-form 
            ref="form" 
            v-model="valid" 
            :lazy-validation="lazy"
        >
            <v-card-subtitle class="text-subtitle-1">
                Te agradecemos que nos proporciones los datos con los que cuentes con la finalidad de poder brindar atención a tu reporte. Los datos recopilados son de carácter CONFIDENCIAL. El llenado del presente formulario es para fines de registro y seguimiento en el entorno universitario, NO CONSTITUYE UNA DENUNCIA FORMAL.
            </v-card-subtitle>

            <v-card-text>
                <v-card
                    outlined
                    style="border-color:#b5a36a;"
                    class="text-center"                        
                >
                    <v-radio-group
                        v-model="esPersonaAfectada"
                        row
                        style="justify-content: center; display: grid;"
                    >
                        <v-radio
                            label="Soy la persona afectada"
                            color="red"
                            :value="true"
                        />
                        <v-radio
                            label="No soy la persona afectada"
                            color="red"
                            :value="false"
                        />
                    </v-radio-group>
                </v-card>
            </v-card-text>

            <v-card-text v-if="esPersonaAfectada != null">
                <v-card
                    v-if="esPersonaAfectada == false"
                    style="border: 1px solid #ffc107;"
                    class="my-4"
                >
                    <v-card-title>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-banner style="border-bottom: thin solid #ffc107;">
                                    <v-icon
                                        slot="icon"
                                        color="#ffc107"
                                        size="36"
                                    >
                                        mdi-account-badge
                                    </v-icon>
                                    <div class="text-h5 font-weight-light">
                                        Datos de quien reporta
                                    </div>
                                </v-banner>
                            </v-col>
                        </v-row>
                    </v-card-title>

                    <v-card-text class="pb-10 px-8">
                        <v-row class="">
                            <v-col
                                cols="12"
                                md="4"
                            >
                                <v-text-field
                                    v-model="prNombre"
                                    label="Nombre y apellidos"
                                    prepend-icon="mdi-account-circle"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="4"
                            >
                                <v-text-field
                                    v-model="prTelefono"
                                    label="Teléfono"
                                    prepend-icon="mdi-phone"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="4"
                            >
                                <v-text-field
                                    v-model="prCorreo"
                                    label="Correo electrónico para recibir notificación"
                                    prepend-icon="mdi-at"
                                    :rules="emailRules"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                                :md="prMostrarCampoNuaNue ? 8 : 12"
                            >
                                <select-rol-institucional
                                    :fn-change="fnChangePrRol"
                                    :requerido="true"
                                    etiqueta="¿Cuál es tu rol institucional?"
                                />
                            </v-col>
                            <v-col
                                v-if="prMostrarCampoNuaNue"
                                cols="12"
                                md="4"
                            >
                                <v-text-field
                                    v-if="prRolInstitucional.idRol == 1"
                                    v-model="prNua"
                                    label="NUA"
                                    prepend-icon="mdi-numeric"
                                />
                                <v-text-field
                                    v-else
                                    v-model="prNue"
                                    label="NUE"
                                    prepend-icon="mdi-numeric"
                                />
                            </v-col>
                        </v-row>
                        <v-row v-if="prMostrarCampoNuaNue">
                            <v-col
                                cols="12"
                                :md="prRolInstitucional.idRol == 1 ? 6 : 4"
                            >
                                <select-campus
                                    :fn-change="fnChangePrCampus"
                                    :id-campus-prop="prCampus.id == null ? null : parseInt(prCampus.id)"
                                    etiqueta="Campus / Colegio del Nivel Medio Superior / Dependencia administrativa"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                :md="prRolInstitucional.idRol == 1 ? 6 : 4"
                            >
                                <select-division
                                    :fn-change="fnChangePrDivision"
                                    :id-campus="prCampus.id == null ? null : parseInt(prCampus.id)"
                                    etiqueta="División / Escuela"
                                />
                            </v-col>
                            <v-col
                                v-if="prRolInstitucional.idRol != 1"
                                cols="12"
                                md="4"
                            >
                                <select-departamento
                                    :fn-change="fnChangePrDepartamento"
                                    :id-division="prDivision.id"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="prRelacion"
                                    label="¿Cuál es la relación que guardas con la persona afectada?"
                                    prepend-icon="mdi-account-multiple"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>


                <v-card
                    class="my-4"
                    style="border: 1px solid #00bcd4;"
                >
                    <v-card-title>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-banner style="border-bottom: thin solid #00bcd4;">
                                    <v-icon
                                        slot="icon"
                                        color="#00bcd4"
                                        size="36"
                                    >
                                        mdi-account
                                    </v-icon>
                                    <div class="text-h5 font-weight-light">
                                        {{ esPersonaAfectada ? 'Datos de receptor de violencia' : 'Datos de la persona que experimentó la violencia' }}
                                    </div>
                                    <div
                                        v-if="!esPersonaAfectada"
                                        class="text-subtitle-2"
                                    >
                                        Indica el nombre de la persona receptora de violencia y/u otros datos que conozcas (Campus, División, Programa educativo, teléfono, etc.) 
                                    </div>
                                </v-banner>
                            </v-col>
                        </v-row>
                    </v-card-title>

                    <v-card-text class="pb-10 px-8">
                        <v-row class="">
                            <v-col
                                cols="12"
                                md="4"
                            >
                                <v-text-field
                                    v-model="rvNombre"
                                    :label="'Nombre y apellidos' + (esPersonaAfectada ? ' *' : '') "
                                    prepend-icon="mdi-account-circle"
                                    :rules="esPersonaAfectada ? [(v) => !!v || 'Campo obligatorio'] : []"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="4"
                            >
                                <v-text-field
                                    v-model="rvTelefono"
                                    :label="'Teléfono' + (esPersonaAfectada ? ' *' : '') "
                                    prepend-icon="mdi-phone"
                                    :rules="esPersonaAfectada ? [(v) => !!v || 'Campo obligatorio'] : []"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                md="4"
                            >
                                <v-text-field
                                    v-model="rvCorreo"
                                    :label="esPersonaAfectada ? 'Correo electrónico para recibir notificación *' : 'Correo electrónico'"
                                    prepend-icon="mdi-at"
                                    :rules="esPersonaAfectada ? emailRulesRequired : emailRules"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="">
                            <v-col
                                cols="12"
                                md="12"
                            >
                                <select-parte-comunidad
                                    :persona-afectada="esPersonaAfectada"
                                    :fn-change="fnChangeRvParteComunidad"
                                    :requerido="false"
                                    :etiqueta="esPersonaAfectada ? '¿Eres parte de la comunidad LGBTTTIQ+?' : '¿Es parte de la comunidad LGBTTTIQ+?'"
                                />                        
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col
                                cols="12"
                                :md="rvMostrarCampoNuaNue ? 8 : 12"
                            >
                                <select-rol-institucional
                                    :fn-change="fnChangeRvRol"
                                    :requerido="true"
                                    :etiqueta="esPersonaAfectada ? '¿Cuál es tu rol institucional?' : ' ¿Cuál es el rol institucional de la persona que experimentó la violencia? '"
                                />
                            </v-col>
                            <v-col
                                v-if="rvMostrarCampoNuaNue"
                                cols="12"
                                md="4"
                            >
                                <v-text-field
                                    v-if="rvRolInstitucional.idRol == 1"
                                    v-model="rvNua"
                                    label="NUA"
                                    prepend-icon="mdi-numeric"
                                />
                                <v-text-field
                                    v-else
                                    v-model="rvNue"
                                    label="NUE"
                                    prepend-icon="mdi-numeric"
                                />
                            </v-col>
                        </v-row>
                        <v-row v-if="rvMostrarCampoNuaNue">
                            <v-col
                                cols="12"
                                :md="rvRolInstitucional.idRol == 1 ? 6 : 4"
                            >
                                <select-campus
                                    :fn-change="fnChangeRvCampus"
                                    :id-campus-prop="rvCampus.id == null ? null : parseInt(rvCampus.id)"
                                    etiqueta="Campus / Colegio del Nivel Medio Superior / Dependencia administrativa"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                                :md="rvRolInstitucional.idRol == 1 ? 6 : 4"
                            >
                                <select-division
                                    :fn-change="fnChangeRvDivision"
                                    :id-campus="rvCampus.id == null ? null : parseInt(rvCampus.id)"
                                    etiqueta="División / Escuela"
                                />
                            </v-col>
                            <v-col
                                v-if="rvRolInstitucional.idRol != 1"
                                cols="12"
                                md="4"
                            >
                                <select-departamento
                                    :fn-change="fnChangeRvDepartamento"
                                    :id-division="rvDivision.id"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>



                <v-card
                    class="my-4"
                    style="border: 1px solid #cddc39;"
                >
                    <v-card-title>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-banner style="border-bottom: thin solid #cddc39;">
                                    <v-icon
                                        slot="icon"
                                        color="#cddc39"
                                        size="36"
                                    >
                                        mdi-file-document
                                    </v-icon>
                                    <div class="text-h5 font-weight-light">
                                        Descripción de lo ocurrido
                                    </div>
                                </v-banner>
                            </v-col>
                        </v-row>
                    </v-card-title>

                    <v-card-text class="pb-10 px-8">
                        <v-row class="">
                            <v-col
                                cols="12"
                            >
                                <v-textarea
                                    v-model="doHecho"
                                    label="¿Qué ocurrió? *"
                                    prepend-icon="mdi-note-text"
                                    placeholder="Relata el hecho"
                                    rows="1"
                                    auto-grow
                                    :rules="[(v) => !!v || 'Campo obligatorio']"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                            >
                                <v-textarea
                                    v-model="doCuando"
                                    label="¿Cuándo ocurrió? *"
                                    prepend-icon="mdi-calendar"
                                    placeholder="Indica la fecha y hora aproximada"
                                    rows="1"
                                    auto-grow
                                    :rules="[(v) => !!v || 'Campo obligatorio']"
                                />
                            </v-col>
                            <v-col
                                cols="12"
                            >
                                <v-textarea
                                    v-model="doDonde"
                                    label="¿Dónde ocurrió? *"
                                    prepend-icon="mdi-map-marker-circle"
                                    placeholder="Escribe el lugar"
                                    rows="1"
                                    auto-grow
                                    :rules="[(v) => !!v || 'Campo obligatorio']"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>




                <v-card
                    class="my-4"
                    style="border: 1px solid gray;"
                >
                    <v-card-title>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-banner style="border-bottom: thin solid gray;">
                                    <v-icon
                                        slot="icon"
                                        color="gray"
                                        size="36"
                                    >
                                        mdi-account-group
                                    </v-icon>
                                    <div class="text-h5 font-weight-light">
                                        Datos de generador(es) de violencia
                                    </div>
                                </v-banner>
                            </v-col>
                        </v-row>
                    </v-card-title>

                    <v-card-text class="pb-10 px-8 py-4">
                        <v-row>
                            <v-col
                                cols="12"
                                class="text-center"
                            >
                                <v-btn
                                    rounded
                                    color="blue" 
                                    dark
                                    @click="fnAddGeneradorViolencia"
                                >
                                    <v-icon left>
                                        mdi-account-plus
                                    </v-icon>
                                    Agregar generador de violencia
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-alert
                                    v-if="itemsGeneradorViolencia.length == 0"
                                    border="left"
                                    colored-border
                                    type="info"
                                    elevation="2"
                                >
                                    Aún no se han agregado generador(es) de violencia.
                                </v-alert>
                                <template v-else>
                                    <informacion-generador-violencia
                                        v-for="(item, index) in itemsGeneradorViolencia"
                                        :key="'item_generador_violencia_' + item.id"
                                        :idx="index"
                                        :obj="item"
                                        :fn-set-value="fnSetValueGeneradorViolencia"
                                        :fn-delete-item="fnRemoveGeneradorViolencia"
                                    />
                                </template>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>


                <v-card
                    class="my-4"
                    style="border: 1px solid #f39c12;"
                >
                    <v-card-title>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-banner style="border-bottom: thin solid #f39c12;">
                                    <v-icon
                                        slot="icon"
                                        color="#f39c12"
                                        size="36"
                                    >
                                        mdi-paperclip
                                    </v-icon>
                                    <div class="text-h5 font-weight-light">
                                        Archivos y/o anexos
                                    </div>
                                    <div
                                        class="text-subtitle-2"
                                    >
                                        <b>Nota:</b> Estimado usuario, si usted cuenta con evidencia que complemente su reporte, favor de adjuntarlo aquí.
                                    </div>
                                </v-banner>
                            </v-col>
                        </v-row>
                    </v-card-title>

                    <v-card-text class="pb-10 px-8 py-4">
                        <v-row>
                            <v-col
                                cols="12"
                                class="text-center"
                            >
                                <dialog-form-anexo
                                    :id-accion="1"
                                    :fn-set-value="fnAddSaveAnexo"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-alert
                                    v-if="itemsAnexos.length == 0"
                                    border="left"
                                    colored-border
                                    type="info"
                                    elevation="2"
                                >
                                    Aún no se han agregado archivos anexos.
                                </v-alert>
                                <v-row
                                    v-else
                                    justify="center"
                                >
                                    <v-col
                                        v-for="(item, index) in itemsAnexos"
                                        :key="'item_div_anexo_' + item.id"
                                        cols="12"
                                        md="3"
                                    >
                                        <informacion-anexo
                                            :key="'item_anexo_' + item.id"
                                            :idx="index"
                                            :obj="item"
                                            :fn-set-value="fnAddSaveAnexo"
                                            :fn-delete-item="fnRemoveAnexo"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <card-aviso-privacidad
                    :aviso-privacidad-prop="objAvisoPrivacidad.avisoPrivacidad"
                    :fn-set-value="fnSetValue"
                />

                <br>

                <v-row>
                    <v-col
                        cols="12"
                        class="text-center"
                    >
                        <div
                            v-if="!valid && mostrarValidacion"
                            class="text-subtitle-2 mb-1"
                            style="color:red;"
                        >
                            Por favor, valide que los campos obligatorios esten completos.
                        </div>
                        <v-btn
                            v-if="showBtnEnviar"
                            x-large
                            color="#0e345b"
                            dark
                            rounded
                            :loading="loadingSave"
                            @click="fnGuardar"
                        >
                            <v-icon left>
                                mdi-send
                            </v-icon>                                
                            ENVIAR REPORTE
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-form>

        <v-snackbar
            key="snackbarFormularioReporte"
            v-model="snackbar"
            :bottom="true"
            :multi-line="true"
            :color="snackbarColor"
        >
            {{ snackbarTexto }}
            <v-btn
                dark
                text
                @click="snackbar = false;"
            >
                Cerrar
            </v-btn>
        </v-snackbar>
    </v-container>
</template>
<script>

import { postFormularioReporte } from "@/api";


export default {
    name: "FormularioReporte",
    components: {
        SelectParteComunidad: () => import("../shared/SelectParteComunidad"),
        SelectRolInstitucional: () => import("../shared/SelectRolInstitucional"),
        SelectCampus: () => import("../shared/SelectCampus"),
        SelectDivision: () => import("../shared/SelectDivision"),
        SelectDepartamento: () => import("../shared/SelectDepartamento"),
        InformacionGeneradorViolencia: () => import("../shared/InformacionGeneradorViolencia"),
        InformacionAnexo: () => import("../shared/InformacionAnexo"),
        DialogFormAnexo: () => import("../shared/DialogFormAnexo"),
        CardAvisoPrivacidad: () => import("../shared/CardAvisoPrivacidad"),
    },
    props: {
    },
    data () {
        return {
            valid: false,
            lazy: false,

            loadingSave: false,
            mostrarValidacion: false,
            showBtnEnviar: true,

            snackbar: false,
            snackbarColor: '',
            snackbarTexto: '', 

            emailRules: [
                v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Escriba un correo electrónico válido'
            ],
            emailRulesRequired: [
                v => !!v || 'Campo obligatorio',
                v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Escriba un correo electrónico válido'
            ],

            esPersonaAfectada: null,

            prRolInstitucional: { idRol: null, dscRol: null },
            prNue: '',
            prNua: null,
            prNombre: '',
            prTelefono: '',
            prCorreo: '',
            prRelacion: '',
            prCampus: { id: null, descripcion: null }, 
            prDivision: { id: null, descripcion: null }, 
            prDepartamento: { id: null, descripcion: null },

            rvRolInstitucional: { idRol: null, dscRol: null },
            rvNue: '',
            rvNua: null,
            rvNombre: '',
            rvTelefono: '',
            rvCorreo: '',
            rvParteComunidad: null,         
            rvCampus: { id: null, descripcion: null }, 
            rvDivision: { id: null, descripcion: null }, 
            rvDepartamento: { id: null, descripcion: null },

            doHecho: '',
            doCuando: '',
            doDonde: '',
            
            itemsGeneradorViolencia: [],
            itemGeneradorViolenciaDefault: {
                id: 0,
                nombre: '',
                rolInstitucional: { idRol: null, dscRol: null },
                campus: { id: null, descripcion: null }, 
                division: { id: null, descripcion: null }, 
                departamento: { id: null, descripcion: null },
            },

            itemsAnexos: [],
            itemAnexoDefault: {
                id: 0,
                descripcion: '',
                file: null,
                filename: ''
            },

            objAvisoPrivacidad: {
                avisoPrivacidad: null,
                incisos: [],
                dpNombre: '',
                dpCorreo: ''
            }

            

        }
    },
    computed: {
        prMostrarCampoNuaNue () {
            if(this.prRolInstitucional != null) {
                if(this.prRolInstitucional.idRol == 1 || this.prRolInstitucional.idRol == 2 || this.prRolInstitucional.idRol == 3) {
                    return true;
                }
            }
            return false;
        },
        rvMostrarCampoNuaNue () {
            if(this.rvRolInstitucional != null) {
                if(this.rvRolInstitucional.idRol == 1 || this.rvRolInstitucional.idRol == 2 || this.rvRolInstitucional.idRol == 3) {
                    return true;
                }
            }
            return false;
        }
    },
    watch: {
        esPersonaAfectada: {
            handler (newValue, oldValue) {
                this.$refs.form.resetValidation()
            }
        },
    },
    async mounted () {
    },
    methods: {
        fnChangePrRol (objRol) {
            this.prRolInstitucional = objRol;
            this.prCampus = { id: null, descripcion: null };
        },
        fnChangePrCampus (objCampus) {
            this.prCampus = objCampus;
            this.prDivision = { id: null, descripcion: null };
        },
        fnChangePrDivision (objDivision) {
            this.prDivision = objDivision;
            this.prDepartamento = { id: null, descripcion: null };
        },
        fnChangePrDepartamento (objDepartamento) {
            this.prDepartamento = objDepartamento;
        },

        fnChangeRvParteComunidad (parteComunidad) {
            this.rvParteComunidad = parteComunidad;
        },
        fnChangeRvRol (objRol) {
            this.rvRolInstitucional = objRol;
            this.rvCampus = { id: null, descripcion: null };
        },
        fnChangeRvCampus (objCampus) {
            this.rvCampus = objCampus;
            this.rvDivision = { id: null, descripcion: null };
        },
        fnChangeRvDivision (objDivision) {
            this.rvDivision = objDivision;
            this.rvDepartamento = { id: null, descripcion: null };
        },
        fnChangeRvDepartamento (objDepartamento) {
            this.rvDepartamento = objDepartamento;
        },
        
        fnAddGeneradorViolencia () {
            var objDefault = Object.assign({}, this.itemGeneradorViolenciaDefault);
            objDefault.id = this.fnGetLastIdGeneradorViolencia() + 1;
            this.itemsGeneradorViolencia.push(objDefault);
        },
        fnRemoveGeneradorViolencia (idx) {
            this.itemsGeneradorViolencia.splice(idx,1); 
        },
        fnSetValueGeneradorViolencia (idx, prop, value) {
            var elem = this.itemsGeneradorViolencia[idx];
            elem[prop] = value
        },
        fnGetLastIdGeneradorViolencia () {
            var lastId = 0;

            if(this.itemsGeneradorViolencia.length > 0) {
                lastId = this.itemsGeneradorViolencia.sort((a,b) => a.id - b.id)[this.itemsGeneradorViolencia.length-1].id;
            }

            return lastId;
        },

        fnAddAnexo () {
            var objDefault = Object.assign({}, this.itemAnexoDefault);
            objDefault.id = this.fnGetLastIdAnexo() + 1;
            this.itemsAnexos.push(objDefault);
        },
        fnAddSaveAnexo (anexo) {

            if(anexo.id > 0) {
                var obj = this.itemsAnexos.filter(n=>n.id == anexo.id)[0];
                obj.file = anexo.file;
                obj.descripcion = anexo.descripcion;
                obj.filename = anexo.filename;
            }
            else{
                anexo.id = this.fnGetLastIdAnexo() + 1;
                this.itemsAnexos.push(anexo);
            }            
        },
        fnRemoveAnexo (idx) {
            this.itemsAnexos.splice(idx,1); 
        },
        fnSetValueAnexo (idx, prop, value) {
            var elem = this.itemsAnexos[idx];
            elem[prop] = value
        },
        fnGetLastIdAnexo () {
            var lastId = 0;

            if(this.itemsAnexos.length > 0) {
                lastId = this.itemsAnexos.sort((a,b) => a.id - b.id)[this.itemsAnexos.length-1].id;
            }

            return lastId;
        },
        fnSetValue (prop, value) {
            this.objAvisoPrivacidad[prop] = value;
        },


        async fnGuardar () {
            var self = this;

            self.mostrarValidacion = true;

            this.$refs.form.validate();
            if(this.valid) {

                self.loadingSave = true;
                self.snackbar = false;
                self.snackbarTexto = "";
                self.snackbarColor = "";

                try{

                    var objFormulario = {
                        esPersonaAfectada: this.esPersonaAfectada,
                        prRolInstitucional: this.prRolInstitucional,
                        prNue: this.prNue,
                        prNua: this.prNua,
                        prNombre: this.prNombre,
                        prTelefono: this.prTelefono,
                        prCorreo: this.prCorreo,
                        prRelacion: this.prRelacion,
                        prCampus: this.prCampus, 
                        prDivision: this.prDivision, 
                        prDepartamento: this.prDepartamento,

                        rvRolInstitucional: this.rvRolInstitucional,
                        rvNue: this.rvNue,
                        rvNua: this.rvNua,
                        rvNombre: this.rvNombre,
                        rvTelefono: this.rvTelefono,
                        rvCorreo: this.rvCorreo,
                        rvParteComunidad: this.rvParteComunidad,
                        rvCampus: this.rvCampus, 
                        rvDivision: this.rvDivision, 
                        rvDepartamento: this.rvDepartamento,

                        doHecho: this.doHecho,
                        doCuando: this.doCuando,
                        doDonde: this.doDonde,
                        
                        itemsGeneradorViolencia: this.itemsGeneradorViolencia,

                        itemsAnexos: this.itemsAnexos,

                        avisoPrivacidad: this.objAvisoPrivacidad.avisoPrivacidad,
                        incisos: this.objAvisoPrivacidad.incisos,
                        dpNombre: this.objAvisoPrivacidad.dpNombre,
                        dpCorreo: this.objAvisoPrivacidad.dpCorreo,
                    }

                    let response = await postFormularioReporte(objFormulario);

                    if (response.status === 200) {
                    if (response.data.flag === true) {
                        if (response.data.message === "Guardado correcto") {
                            //self.snackbarTexto = "Reporte con folio " + response.data.data + " enviado con éxito";
                            self.snackbarTexto = "Su reporte ha sido capturado con éxito, el área encargada de atenderle se pondrá en contacto con usted a través de correo electrónico.";
                            self.snackbarColor = "success";
                            self.snackbar = true;
                            self.showBtnEnviar = false;
                        }
                    } else {
                        self.snackbarTexto = "FormularioReporte: " + response.data.message;
                        self.snackbarColor = "error";
                        self.snackbar = true;
                    }
                    } else {
                    self.snackbarTexto = "FormularioReporte: Error de red";
                    self.snackbarColor = "error";
                    self.snackbar = true;
                    }
                    self.loadingSave = false;

                } catch (e) {
                    self.loadingSave = false;
                    self.snackbarTexto = "FormularioReporte: " + e;
                    self.snackbarColor = "error";
                    self.snackbar = true;
                }
            }

        }
    },
}
</script>

<style scoped>

</style>